import React from 'react';
import DataTableWrapper from '../DataTableWrapper';

const DataTable = ({ records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage }) => {
    return (
        <DataTableWrapper
            loading={loading} currentPage={currentPage} setCurrentPage={setCurrentPage}
            totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
        >
            <table className="table table-striped table-hover table-bordered align-middle text-center mb-0" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th rowSpan={3}>Sr. No.</th>
                                <th rowSpan={3}>Report Date</th>
                                <th rowSpan={3}>District Name</th>
                                <th rowSpan={3} className="section-divider">State Name</th>

                                <th colSpan={4} className="cohort-header-preg section-divider">Preg. Women (15-49 Y)</th>
                                <th colSpan={4} className="cohort-header-children section-divider">Children (6-59 M)</th>
                                <th colSpan={4} className="cohort-header-child section-divider">Child (5-9 Y)</th>
                                <th colSpan={4} className="cohort-header-adolescents section-divider">Adolescents (10-19 Y)</th>
                                <th colSpan={4} className="cohort-header-wra section-divider">WRA (20-49 Y)</th>
                                <th colSpan={4} className="cohort-header-lactating section-divider">Lactating Mother</th>
                                <th colSpan={4} className="cohort-header-men section-divider">Men (15-49 Y)</th>
                                <th colSpan={4} className="cohort-header-senior">Senior Women (49+ Y)</th>
                            </tr>
                            <tr>
                                {/* Preg. Women (15-49 Y) */}
                                <th className="cohort-preg">Non Anaemic</th>
                                <th className="cohort-preg">Mild</th>
                                <th className="cohort-preg">Moderate</th>
                                <th className="cohort-preg section-divider">Severe</th>

                                {/* Children (6-59 M) */}
                                <th className="cohort-children">Non Anaemic</th>
                                <th className="cohort-children">Mild</th>
                                <th className="cohort-children">Moderate</th>
                                <th className="cohort-children section-divider">Severe</th>

                                {/* Child (5-9 Y) */}
                                <th className="cohort-child">Non Anaemic</th>
                                <th className="cohort-child">Mild</th>
                                <th className="cohort-child">Moderate</th>
                                <th className="cohort-child section-divider">Severe</th>

                                {/* Adolescents (10-19 Y) */}
                                <th className="cohort-adolescents">Non Anaemic</th>
                                <th className="cohort-adolescents">Mild</th>
                                <th className="cohort-adolescents">Moderate</th>
                                <th className="cohort-adolescents section-divider">Severe</th>

                                {/* WRA (20-49 Y) */}
                                <th className="cohort-wra">Non Anaemic</th>
                                <th className="cohort-wra">Mild</th>
                                <th className="cohort-wra">Moderate</th>
                                <th className="cohort-wra section-divider">Severe</th>

                                {/* Lactating Mother */}
                                <th className="cohort-lactating">Non Anaemic</th>
                                <th className="cohort-lactating">Mild</th>
                                <th className="cohort-lactating">Moderate</th>
                                <th className="cohort-lactating section-divider">Severe</th>

                                {/* Men (15-49 Y) */}
                                <th className="cohort-men">Non Anaemic</th>
                                <th className="cohort-men">Mild</th>
                                <th className="cohort-men">Moderate</th>
                                <th className="cohort-men section-divider">Severe</th>

                                {/* Senior Women (49+ Y) */}
                                <th className="cohort-senior">Non Anaemic</th>
                                <th className="cohort-senior">Mild</th>
                                <th className="cohort-senior">Moderate</th>
                                <th className="cohort-senior">Severe</th>
                            </tr>
                            <tr className="text-center align-middle sub-header-ranges">
                                {[...Array(8)].map((_, i) => {
                                    const classes = [
                                        "cohort-preg", "cohort-children", "cohort-child", "cohort-adolescents",
                                        "cohort-wra", "cohort-lactating", "cohort-men", "cohort-senior"
                                    ];
                                    const baseClass = classes[i];
                                    return (
                                        <React.Fragment key={i}>
                                            <th className={baseClass} style={{ fontSize: 10 }}>&gt; 11 g/dl</th>
                                            <th className={baseClass} style={{ fontSize: 10 }}>10–10.9 g/dl</th>
                                            <th className={baseClass} style={{ fontSize: 10 }}>7-9.9 g/dl</th>
                                            <th className={`${baseClass} section-divider`} style={{ fontSize: 10 }}>&lt; 7 g/dl</th>
                                        </React.Fragment>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((r, idx) => (
                                <tr key={r.id || idx}>
                                    <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                                    <td>{r.report_date}</td>
                                    <td><strong className="text-body">{r.district_name}</strong></td>
                                    <td className="section-divider">{r.state_name}</td>

                                    <td className="cohort-preg">{r.preg_non_anaemic}</td>
                                    <td className="cohort-preg">{r.preg_mild}</td>
                                    <td className="cohort-preg">{r.preg_moderate}</td>
                                    <td className="cohort-preg color-severe section-divider">{r.preg_severe}</td>

                                    <td className="cohort-children">{r.child_6_59m_non_anaemic}</td>
                                    <td className="cohort-children">{r.child_6_59m_mild}</td>
                                    <td className="cohort-children">{r.child_6_59m_moderate}</td>
                                    <td className="cohort-children color-severe section-divider">{r.child_6_59m_severe}</td>

                                    <td className="cohort-child">{r.child_5_9y_non_anaemic}</td>
                                    <td className="cohort-child">{r.child_5_9y_mild}</td>
                                    <td className="cohort-child">{r.child_5_9y_moderate}</td>
                                    <td className="cohort-child color-severe section-divider">{r.child_5_9y_severe}</td>

                                    <td className="cohort-adolescents">{r.child_10_19y_non_anaemic}</td>
                                    <td className="cohort-adolescents">{r.child_10_19y_mild}</td>
                                    <td className="cohort-adolescents">{r.child_10_19y_moderate}</td>
                                    <td className="cohort-adolescents color-severe section-divider">{r.child_10_19y_severe}</td>

                                    <td className="cohort-wra">{r.wra_20_49y_non_anaemic}</td>
                                    <td className="cohort-wra">{r.wra_20_49y_mild}</td>
                                    <td className="cohort-wra">{r.wra_20_49y_moderate}</td>
                                    <td className="cohort-wra color-severe section-divider">{r.wra_20_49y_severe}</td>

                                    <td className="cohort-lactating">{r.lactating_non_anaemic}</td>
                                    <td className="cohort-lactating">{r.lactating_mild}</td>
                                    <td className="cohort-lactating">{r.lactating_moderate}</td>
                                    <td className="cohort-lactating color-severe section-divider">{r.lactating_severe}</td>

                                    <td className="cohort-men">{r.men_19plus_non_anaemic}</td>
                                    <td className="cohort-men">{r.men_19plus_mild}</td>
                                    <td className="cohort-men">{r.men_19plus_moderate}</td>
                                    <td className="cohort-men color-severe section-divider">{r.men_19plus_severe}</td>

                                    <td className="cohort-senior">{r.women_49plus_non_anaemic}</td>
                                    <td className="cohort-senior">{r.women_49plus_mild}</td>
                                    <td className="cohort-senior">{r.women_49plus_moderate}</td>
                                    <td className="cohort-senior color-severe">{r.women_49plus_severe}</td>
                                </tr>
                            ))}
                            {records.length === 0 && (
                                <tr>
                                    <td colSpan={40} className="text-center py-4 text-muted">
                                        No records match the current filters.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
        </DataTableWrapper>
    );
};

export default DataTable;
